import { Injectable } from '@angular/core';
import { Resource } from '../model/resource';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Serializer } from '../model/serializer/serializer';
import { map } from 'rxjs/operators';
import { QueryOptions } from '../model/query-options';
import { ServerResponse } from '@app/model/serverResponse';
import { JobSerializer } from '@app/model/serializer/job-serializer';


export abstract class ApiService<T extends Resource> {
  constructor(
    private httpClient: HttpClient,
    private url: string,
    private endpoint: string,
    private serializer: Serializer) { }

  public create(item: T,endpoint?:any): Observable<T> {
    //debugger;
    if(endpoint){
      this.endpoint=endpoint;
    }
    return this.httpClient
      .post<T>(`${this.url}/${this.endpoint}`, this.serializer.toJson(item))
      .pipe(map(data => this.serializer.fromJson(data) as T));
  }

  public post(item: any,endpoint?:any): Observable<any> {
    //debugger;
    if(endpoint){
      this.endpoint=endpoint;
    }
    return this.httpClient
      .post<any>(`${this.url}/${this.endpoint}`, item);
  }

  public editJob(item: T,endpoint?:any): Observable<T> {
     //debugger;
     if(endpoint){
      this.endpoint=endpoint;
     }
    return this.httpClient
      .put<T>(`${this.url}/${this.endpoint}`, this.serializer.toJson(item))
      .pipe(map(data => this.serializer.fromJson(data) as T));
  }

  public createFile(item: any,endpoint?:any): Observable<T> {
    if(endpoint){
      this.endpoint=endpoint;
     }
    //debugger;
    const formData = new FormData();
    formData.append('multipartFile', item);
    return this.httpClient
      .post(`${this.url}/${this.endpoint}`, formData)
      .pipe(map(data => this.serializer.fromJson(data) as T));
  }

  public update(item: any,endpoint?:any): Observable<T> {
    if(endpoint){
      this.endpoint=endpoint;
     }
    return this.httpClient
      .put<T>(`${this.url}/${this.endpoint}`,
        this.serializer.toJson(item))
      .pipe(map(data => this.serializer.fromJson(data) as T));
  }

  read(id: any,endpoint?:any): Observable<T> {
    if(endpoint){
      this.endpoint=endpoint;
    }
    return this.httpClient
      .get(`${this.url}/${this.endpoint}/${id}`)
      .pipe(map((data: any) => this.serializer.fromJson(data) as T));
  }

  get(id?: number,queryOptions?: QueryOptions,endpoint?:any): Observable<T> {
    if(endpoint){
      this.endpoint=endpoint;
    }
    let queryString = ""
    if (queryOptions) {
      queryString = "?";
      queryString += queryOptions.toQueryString();
    }
    return this.httpClient
      .get(`${this.url}/${this.endpoint}/${id}${queryString}`)
      .pipe(map((data: any) => this.serializer.fromJson(data) as T));
  }

  list(queryOptions?: QueryOptions, endpoint?: any, id?: any,newqueryString?:any): Observable<T[]> {
    if(endpoint){
      this.endpoint=endpoint;
    }
    let queryString = ""
    if (queryOptions) {
      queryString = "?";
      queryString += queryOptions.toQueryString();
    }
    if(id){
      return this.httpClient
      .get(`${this.url}/${this.endpoint}/${id}${queryString}`)
      .pipe(map((data: any) => data && data.content? this.convertData(data.content):this.convertData(data)));
    }
    else if(newqueryString){
      return this.httpClient
      .get(`${this.url}/${this.endpoint}${queryString}${newqueryString}`)
      .pipe(map((data: any) => data && data.content? this.convertData(data.content):this.convertData(data)));
    }
    else{
      return this.httpClient
      .get(`${this.url}/${this.endpoint}${queryString}`)
      .pipe(map((data: any) => data && data.content? this.convertData(data.content):this.convertData(data)));
    }

  }

    getCVSubmit(jdId?: QueryOptions, endpoint?: any, recruiteIid?: any, submitDate?: any): Observable<T> {
        if(endpoint){
            this.endpoint = endpoint;
        }
        if(recruiteIid && jdId && submitDate){
          return this.httpClient
              .get(`${this.url}/${this.endpoint}?jdId=${jdId}&recruiterId=${recruiteIid}&submitDate=${submitDate}`)
              .pipe(map(data => this.serializer.fromJson(data) as T));
      }
        if(recruiteIid && jdId){
            return this.httpClient
                .get(`${this.url}/${this.endpoint}?jdId=${jdId}&recruiterId=${recruiteIid}`)
                .pipe(map(data => this.serializer.fromJson(data) as T));
        }
    }

  newList(queryOptions?: QueryOptions): Observable<ServerResponse> {
    let queryString = "";
    if (queryOptions) {
      queryString = "?";
      queryString += queryOptions.toQueryString();
    }
    return this.httpClient
      .get(`${this.url}/${this.endpoint}${queryString}`)
      .pipe(map((data: any) => {
        let resp: ServerResponse = new ServerResponse();
        resp['content'] = this.newConvertData(data.content);
        resp['pageSize'] = data.pageSize;
        resp['totalPages'] = data.totalPages;
        resp['totalRecords'] = data.count;
        resp['message'] = data.message;
        resp['errorMessage'] = data.errorMessage;
        return resp;}));
  }

  newList1(queryOptions?: QueryOptions): Observable<ServerResponse> {
    let queryString = "";
    if (queryOptions) {
      queryString = "?";
      queryString += queryOptions.toQueryString();
    }
   this.serializer= new JobSerializer();
    return this.httpClient
      .get(`${this.url}/${this.endpoint}${queryString}`)
      .pipe(map((data: any) => {
        let resp: ServerResponse = new ServerResponse();
        resp['content'] = this.newConvertData(data.content);
        resp['pageSize'] = data.pageSize;
        resp['totalPages'] = data.totalPages;
        resp['totalRecords'] = data.count;
        resp['message'] = data.message;
        resp['errorMessage'] = data.errorMessage;
        return resp;}));
  }

  delete(id?: any) {
    return this.httpClient
      .delete(`${this.url}/${this.endpoint}/${id}`);
  }

  deleteRecruiter(endpoint?: string, id?: any) {
    if(endpoint){
      return this.httpClient
      .delete(`${this.url}/${endpoint}/${id}`);
    }
    return this.httpClient
      .delete(`${this.url}/${this.endpoint}/${id}`);
  }

  private convertData(data: any): T[] {
    return data.map(item => this.serializer.fromJson(item));
  }

  private newConvertData(data: any): ServerResponse {
    return data.map(item => this.serializer.fromJson(item));
  }
}
